import React, { ReactNode } from 'react'
import { useWindowDimensions } from 'react-native'

import styled from 'styled-components/native'

import { Display } from '../../atoms/display/Display'
import { CheckboxGroup } from '../../atoms/formElements/CheckboxGroup'
import { DisplaySize } from '../../styles/typeStyles'

export enum DocumentStatus {
  INCOMPLETE = 'Incomplete',
  DRAFT = 'Draft',
  COMPLETED = 'Completed',
  UPLOADED = 'Uploaded',
  DECLINED = 'Declined',
}

export enum DocumentType {
  INTAKE_FORM = 'Intake form',
  ASSESSMENT = 'Assessment',
  ACTIVITY = 'Activity',
  OTHER = 'Other',
}

export type DocumentFiltersState = {
  status: DocumentStatus[]
  type: DocumentType[]
  addedBy: string[]
}

export const INITIAL_DOCUMENT_FILTER_STATE: DocumentFiltersState = {
  status: [],
  type: [],
  addedBy: [],
}

export type FilterSectionConfig<T> = {
  key: keyof T & string
  label: ReactNode
  options: { id: string; text: string }[]
}

type DocumentFiltersPopoverProps<T> = {
  filterState: T
  onFilterStateChange: (filterState: T) => void
  sections: FilterSectionConfig<T>[]
}

const Container = styled.View(({ theme }) => ({
  border: `1px solid ${theme.colors.borderDefault}`,
  boxShadow: `0 4px 16px ${theme.colors.shadowLow}`,
  width: '320px',
  borderRadius: '16px',
  backgroundColor: theme.colors.backgroundPrimary,
}))

const SectionsContainer = styled.View<{ windowHeight: number }>(({ theme, windowHeight }) => ({
  padding: theme.spacing['24px'],
  gap: theme.spacing['16px'],
  maxHeight: windowHeight >= 750 ? '504px' : '304px',
  overflow: 'auto',
}))

const FilterSection = styled.View(({ theme }) => ({
  gap: theme.spacing['8px'],
}))

export const DocumentFiltersPopover = <T,>({
  filterState,
  onFilterStateChange,
  sections,
}: DocumentFiltersPopoverProps<T>) => {
  const { height } = useWindowDimensions()

  return (
    <Container>
      <SectionsContainer windowHeight={height}>
        {sections.map((section) => (
          <FilterSection key={section.key}>
            <Display size={DisplaySize.EYEBROW} text={section.label} />
            <CheckboxGroup
              options={section.options}
              value={filterState[section.key] as string[]}
              onChange={(values) => onFilterStateChange({ ...filterState, [section.key]: values })}
              name={section.key}
              baseInputStyle={{ marginBottom: 0 }}
              checkboxStyle={{ marginRight: 16 }}
              checkboxInputStyle={{ marginBottom: 8 }}
            />
          </FilterSection>
        ))}
      </SectionsContainer>
    </Container>
  )
}
